import _ from 'lodash';
import React from 'react';
import PropTypes from 'prop-types';
import Radium from 'radium';
import update from 'react-addons-update';

import * as styles from '../../styles';
import {request} from '../../containers/actions';


//Radium(PostPrices);
export default class PostPrices extends React.PureComponent {
    static contextTypes = {
        store: PropTypes.object,
    }

    state = {
        froM: '',
        to: '',
        priceSame: '',
        priceNeighbor: '',
        priceFar: '',
    }

    constructor(props) {
        super(props);
        this.add = this.add.bind(this);
    }

    componentDidMount() {
        this.fetch();
    }

    async fetch() {
        const response = await this.context.store.dispatch(request({
            path: `/post-price/?type=${this.props.type}&limit=1000`,
        }));
        this.setState({prices: response.results});
    }

    async save() {
        try {
            await this.context.store.dispatch([
                request({
                    path: '/post-price/',
                    method: 'PATCH',
                    body: _.filter(this.state.prices, price => !price.removed && Number(String(price.id)) === price.id),
                }),
                request({
                    path: '/post-price/',
                    method: 'POST',
                    body: _.filter(this.state.prices, price => !price.removed && Number(String(price.id)) !== price.id),
                }),
                ..._.some(this.state.prices, price => price.removed)
                    ? [request({
                        path: `/post-price/?id=${_.map(_.filter(
                            this.state.prices,
                            price => price.removed && Number(String(price.id)) === price.id,
                        ), 'id')}`,
                        method: 'DELETE',
                    })]
                    : [],
            ]);
            await this.fetch();
            this.setState({saved: true});
            setTimeout(() => this.setState({saved: undefined}), 2500);
        }
        catch (exception) {
            this.setState({saved: false});
            setTimeout(() => this.setState({saved: undefined}), 2500);
        }
    }

    add() {
        this.setState(update(
            this.state,
            {
                froM: {$set: this.state.to},
                to: {$set: ''},
                priceSame: {$set: ''},
                priceNeighbor: {$set: ''},
                priceFar: {$set: ''},
                prices: {$push: [{
                    type: this.props.type,
                    froM: this.state.froM,
                    to: this.state.to,
                    'price_same': this.state.priceSame,
                    'price_neighbor': this.state.priceNeighbor,
                    'price_far': this.state.priceFar,
                    id: window.uuidv4(),
                }]},
            },
        ));
        this.refs.to.focus();
    }

    render() {
        if (!this.state.prices)
            return null;
        return <div>
            <div style={{position: 'relative'}}>
                <div
                    style={{
                        position: 'absolute',
                        right: '50%',
                        transform: 'translateX(50%)',
                        marginTop: '-.25em',
                        fontWeight: '500',
                        fontSize: '1.4em',
                    }}>
                    {this.props.type === 0 ? window.gettext('Bespoke Post') : window.gettext('Pishtaz Post')}
                </div>
                <button
                    key='save'
                    style={{
                        ...styles.button,
                        float: 'left',
                        marginRight: '.5em',
                        ...this.state.saved === true
                            ? {
                                backgroundColor: styles.successBackColor,
                            }
                            : this.state.saved === false
                                ? {
                                    backgroundColor: styles.alertBackColor,
                                }
                                : {
                                    backgroundColor: 'white',
                                    transition: 'background-color 3500ms',
                                },
                    }}
                    onClick={() => {
                        if (!window.confirm(window.gettext('Are you sure yo wanna overwrite prices?')))
                            return;
                        this.save.bind(this)();
                    }}>
                    {window.gettext('Save')}
                </button>
            </div>
            <div>
                <br/>
                {window.gettext('From')}
                &nbsp;
                <input
                    key='from'
                    style={styles.input}
                    size='3'
                    value={this.state.froM.persian()}
                    onChange={({target: {value}}) => {
                        if (value === '' || value.english().replace(/\.$/, '') === Number(value.english().replace(/\.$/, '')).toString())
                            this.setState({froM: value.english()});
                    }}
                />
                &nbsp;
                {window.gettext('KG')}
                &nbsp;
                {window.gettext('To')}
                &nbsp;
                <input
                    key='to'
                    ref='to'
                    style={styles.input}
                    size='3'
                    value={this.state.to.persian()}
                    onChange={({target: {value}}) => {
                        if (value === '' || value.english().replace(/\.$/, '') === Number(value.english().replace(/\.$/, '')).toString())
                            this.setState({to: value.english()});
                    }}
                />
                &nbsp;
                {window.gettext('KG')}
                &nbsp;
                {window.gettext('For')}
                &nbsp;
                {window.gettext('Same Region')}
                &nbsp;:&nbsp;
                <input
                    key='price-same'
                    style={styles.input}
                    size='6'
                    value={this.state.priceSame.persian()}
                    onChange={({target: {value}}) => {
                        if (value === '' || value.english() === Number(value.english()).toString())
                            this.setState({priceSame: value.english()});
                    }}
                    onKeyPress={event => {
                        if ((event.keyCode || event.charCode) == 13)
                            this.add();
                    }}
                />
                &nbsp;
                {window.gettext('Tooman')}
                &nbsp;
                {window.gettext('Neighbor Region')}
                &nbsp;:&nbsp;
                <input
                    key='price-neighbor'
                    style={styles.input}
                    size='6'
                    value={this.state.priceNeighbor.persian()}
                    onChange={({target: {value}}) => {
                        if (value === '' || value.english() === Number(value.english()).toString())
                            this.setState({priceNeighbor: value.english()});
                    }}
                    onKeyPress={event => {
                        if ((event.keyCode || event.charCode) == 13)
                            this.add();
                    }}
                />
                &nbsp;
                {window.gettext('Tooman')}
                &nbsp;
                {window.gettext('Far Region')}
                &nbsp;:&nbsp;
                <input
                    key='price-far'
                    style={styles.input}
                    size='6'
                    value={this.state.priceFar.persian()}
                    onChange={({target: {value}}) => {
                        if (value === '' || value.english() === Number(value.english()).toString())
                            this.setState({priceFar: value.english()});
                    }}
                    onKeyPress={event => {
                        if ((event.keyCode || event.charCode) == 13)
                            this.add();
                    }}
                />
                &nbsp;
                {window.gettext('Tooman')}
                <br/>
                <button
                    style={{...styles.defaultButton, minWidth: undefined, marginTop: '.5em', fontSize: '1.2em'}}
                    onClick={this.add}>
                    <i className='fa-plus'/>
                </button>
                <br/>
            </div>
            {_.map(
                _.sortBy(_.filter(this.state.prices, price => !price.removed), 'froM'),
                price => <div key={price.id}>
                    <button
                        style={{...styles.defaultButton, marginTop: '.5em', minWidth: undefined, backgroundColor: styles.fourthColor}}
                        onClick={() => this.setState(update(this.state, {
                            prices: {$splice: [[_.findIndex(this.state.prices, p => p.id === price.id), 1, {...price, removed: true}]]},
                        }))}>
                        <i className='fa-times'/>
                    </button>
                    &nbsp;
                    {window.gettext('From')}
                    &nbsp;
                    <input
                        key={'from' + price.id}
                        style={styles.input}
                        size='3'
                        value={price.froM.persian()}
                        onChange={({target: {value}}) => this.setState(update(this.state, {prices: {
                            $splice: [[_.findIndex(this.state.prices, p => p.id === price.id), 1, {...price, froM: value.english()}]],
                        }}))}
                    />
                    &nbsp;
                    {window.gettext('KG')}
                    &nbsp;
                    {window.gettext('To')}
                    &nbsp;
                    <input
                        key={'to' + price.id}
                        style={styles.input}
                        size='3'
                        value={price.to.persian()}
                        onChange={({target: {value}}) => this.setState(update(this.state, {prices: {
                            $splice: [[_.findIndex(this.state.prices, p => p.id === price.id), 1, {...price, to: value.english()}]],
                        }}))}
                    />
                    &nbsp;
                    {window.gettext('KG')}
                    &nbsp;
                    {window.gettext('For')}
                    &nbsp;
                    {window.gettext('Same Region')}
                    &nbsp;:&nbsp;
                    <input
                        key={'price-same-' + price.id}
                        style={styles.input}
                        size='6'
                        value={price.price_same.persian()}
                        onChange={({target: {value}}) => this.setState(update(this.state, {prices: {
                            $splice: [[_.findIndex(this.state.prices, p => p.id === price.id), 1, {...price, 'price_same': value.english()}]],
                        }}))}
                    />
                    &nbsp;
                    {window.gettext('Tooman')}
                    &nbsp;
                    {window.gettext('Neighbor Region')}
                    &nbsp;:&nbsp;
                    <input
                        key={'price-neighbor-' + price.id}
                        style={styles.input}
                        size='6'
                        value={price.price_neighbor.persian()}
                        onChange={({target: {value}}) => this.setState(update(this.state, {prices: {
                            $splice: [[_.findIndex(this.state.prices, p => p.id === price.id), 1, {...price, 'price_neighbor': value.english()}]],
                        }}))}
                    />
                    &nbsp;
                    {window.gettext('Tooman')}
                    &nbsp;
                    {window.gettext('Far Region')}
                    &nbsp;:&nbsp;
                    <input
                        key={'price-far-' + price.id}
                        style={styles.input}
                        size='6'
                        value={price.price_far.persian()}
                        onChange={({target: {value}}) => this.setState(update(this.state, {prices: {
                            $splice: [[_.findIndex(this.state.prices, p => p.id === price.id), 1, {...price, 'price_far': value.english()}]],
                        }}))}
                    />
                    &nbsp;
                    {window.gettext('Tooman')}
                </div>,
            )}
        </div>;
    }
}
